// Caméra (Lot E) : offset de dessin (px) pour suivre le coureur local sur les grandes cartes.
// Fonction PURE (aucun DOM, aucune dépendance) -> testable hors navigateur. Le viewport à l'écran
// reste viewW×viewH ; la carte peut être plus grande (mapW×mapH). L'offset centre le point suivi
// (focusX,focusY = centre du coureur, en px) et est CLAMPÉ aux bords de la carte, puis arrondi à
// l'entier (pixel-art net). Carte <= viewport -> offset (0,0) = rendu bit-identique à l'historique
// (map-view <= 0 => borne haute 0 => clamp force 0).
export function cameraOffset(
  focusX: number, focusY: number,
  mapW: number, mapH: number,
  viewW: number, viewH: number,
): { x: number; y: number } {
  const clamp = (v: number, hi: number): number => (v < 0 ? 0 : v > hi ? hi : v)
  return {
    x: Math.round(clamp(focusX - viewW / 2, Math.max(0, mapW - viewW))),
    y: Math.round(clamp(focusY - viewH / 2, Math.max(0, mapH - viewH))),
  }
}
